import { render } from "./PrioritiseCombination.vue?vue&type=template&id=b0ff2470"
import script from "./PrioritiseCombination.vue?vue&type=script&lang=js"
export * from "./PrioritiseCombination.vue?vue&type=script&lang=js"

import "./PrioritiseCombination.vue?vue&type=style&index=0&id=b0ff2470&lang=css"
script.render = render

export default script